"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvancedActions = AdvancedActions;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const classnames_1 = __importDefault(require("classnames"));
const prop_types_1 = __importDefault(require("prop-types"));
const AdvancedAction_1 = require("./AdvancedAction");
const link_generation_1 = require("../../utils/link-generation");
const AdvancedActions_module_scss_1 = __importDefault(require("./AdvancedActions.module.scss"));
function AdvancedActions({ isVisible, tokenApiUrl, overridesParam = 'ldOverrides', bypassCacheParam = 'sku' }) {
    const advancedClasses = (0, classnames_1.default)(AdvancedActions_module_scss_1.default.container, {
        [AdvancedActions_module_scss_1.default['is-visible']]: isVisible
    });
    const clearOverridesUrl = (0, link_generation_1.addQueryString)('ldOverrides', 'clear'); // currently we're not removing this... so it's up to the dev to remove it from the url if needed
    const timestamp = new Date;
    const bypassCacheUrl = (0, link_generation_1.addQueryString)('sku', timestamp.getTime());
    return ((0, jsx_runtime_1.jsxs)("div", { className: advancedClasses, children: [overridesParam && (0, jsx_runtime_1.jsx)(AdvancedAction_1.AdvancedAction, { title: "Clear all launch darkly flag overrides", undo: true, icon: "flag", href: clearOverridesUrl }), tokenApiUrl && (0, jsx_runtime_1.jsx)(AdvancedAction_1.AdvancedAction, { title: "Generate token for X-LD-CONFIG header", icon: "generating_tokens", onClick: () => generateToken(tokenApiUrl) }), bypassCacheParam && (0, jsx_runtime_1.jsx)(AdvancedAction_1.AdvancedAction, { title: "Bypass CloudFront cache", icon: "start", href: bypassCacheUrl })] }));
}
const copyToClipboard = async (text, message) => {
    try {
        await navigator.clipboard.writeText(text);
        alert(`The token has been copied to your clipboard. ${message}`);
    }
    catch (e) {
        alert(`Whoops! The token wasn't copied because: ${e.message}`);
    }
};
const generateToken = async (tokenApiUrl) => {
    fetch(`${tokenApiUrl}`)
        .then((res) => {
        return res.json();
    }, (error) => {
        console.log('[LaunchDarklyWidget.generateToken] error generating token:', error);
    }).then((res) => {
        /* if DevTools are open, we need to provide a little extra time to switch
  focus to the main window for access to the ClipBoard API */
        setTimeout(() => { copyToClipboard(res.token, res.message); }, 1000);
    });
};
AdvancedActions.propTypes = {
    /** Hides and shows Advanced Actions panel */
    isVisible: prop_types_1.default.bool,
    /** The url used to generate a token as the viewer request event does in cloud front */
    tokenApiUrl: prop_types_1.default.string,
    /** The query param used to clear override cookie. Pass `null` if you want to hide this option */
    overridesParam: prop_types_1.default.string,
    /** The query param used to bypass CF cache. Pass `null` if you want to hide this option */
    bypassCacheParam: prop_types_1.default.string
};
//# sourceMappingURL=AdvancedActions.js.map